import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["select", "uploader", "colorField", "hint"];

  change() {
    const value = this.selectTarget.value;
    this.uploaderTarget.hidden = value !== "custom";
    this.colorFieldTarget.hidden = value === "none";
    this.hintTargets.forEach((hint) => {
      hint.hidden = hint.dataset.source !== value;
    });
  }
}
